<template>
    <div class="card">
        <div class="card-header d-flex justify-content-between align-items-center">
            <div>{{ group.group_type_name }}情報</div>
        </div>

        <div class="card-body small">
            <div class="row">
                <div class="col-12 col-md-3">{{ group.group_type_name }}名</div>
                <div class="col-12 col-md-9">{{ group.name }}</div>
            </div>
            <hr>
            <div class="row">
                <div class="col-12 col-md-3">ステータス</div>
                <div class="col-12 col-md-9">
                    <span v-if="isPaused" class="text-danger font-weight-bold">利用停止中</span>
                    <span v-else class="text-success font-weight-bold">利用中</span>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-12 col-md-3">所属人数</div>
                <div class="col-12 col-md-9">{{ group.user_count }}名</div>
            </div>
            <hr>
            <div class="row">
                <div class="col-12 col-md-3">代表者</div>
                <div class="col-12 col-md-9">{{ group.representative || '-' }}</div>
            </div>
            <hr>
            <div class="row">
                <div class="col-12 col-md-3">住所</div>
                <div class="col-12 col-md-9">{{ group.address || '-' }}</div>
            </div>
            <template v-if="isPaused">
                <hr>
                <div class="row">
                    <div class="col-12">
                        <p class="mb-0 notice">利用停止中は「{{ $locale.consultation_host }}予約」および「{{ $locale.consultation_host }}記録の閲覧」機能をご利用いただくことはできません。<br>利用再開のお手続きに関しましては、<a href="https://yokumiru.jp/contact-hojin">こちら</a>&nbsp;からお問い合わせください。</p>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import YokumiruHelper from '../../../YokumiruHelper'

    export default {
        props: {
            group: {
                type: Object,
                required: true,
            },
            parentGroup: {
                type: Object,
                default: null,
            },
        },

        computed: {
            isPaused: function () {
                return this.group.flg_paused || (this.parentGroup && this.parentGroup.flg_paused)
            },
        },

        data: function () {
            return {
                helper: YokumiruHelper,
            }
        },
    }
</script>

<style scoped lang="scss">
.notice {
    font-size: 13px;

    a {
        text-decoration: underline;

        &:hover {
            text-decoration: none;
        }
    }
}
</style>
